// Contas Líder: duas abas, as contas a receber e o pipeline do que ainda vem aí.
import { useState } from "react";
import { ds } from "./desenho";
import ContasLider from "./ContasLider";
import Pipeline from "./PipelineLider";
import { btnPrincipal, btnSecundario } from "./FinanceiroComum";

export default function ContasLiderPagina(props) {
  const [aba, setAba] = useState("contas");
  const { supabase, negocios, comissoes, propostas, consultores, leads, recebimentos, referencias, isLider, onAviso } = props;
  return (
    <div style={{ fontFamily: ds.letra }}>
      <div role="tablist" aria-label="Contas Líder" style={{ display: "flex", gap: 6, padding: "8px 0" }}>
        <button role="tab" aria-selected={aba === "contas"} onClick={() => setAba("contas")} style={aba === "contas" ? btnPrincipal : btnSecundario}>Contas a receber</button>
        <button role="tab" aria-selected={aba === "pipeline"} onClick={() => setAba("pipeline")} style={aba === "pipeline" ? btnPrincipal : btnSecundario}>Pipeline</button>
      </div>
      {aba === "contas" ? <ContasLider {...props} /> : (
        <div style={{ padding: "8px 0" }}>
          <h1 style={{ margin: "0 0 12px", fontSize: 24 }}>Pipeline</h1>
          <Pipeline supabase={supabase} negocios={negocios} comissoes={comissoes} propostas={propostas} consultores={consultores} leads={leads} recebimentos={recebimentos} referencias={referencias} isLider={isLider} onAviso={onAviso} />
        </div>
      )}
    </div>
  );
}
